<button [attr.data-tooltip]="tooltipText" class="button">
  <div class="button-wrapper">
    <div class="text">
      <span class="material-symbols-outlined">add</span>
      <span>{{ text }}</span>
    </div>
    <span class="icon material-symbols-outlined">keyboard_arrow_down</span>
  </div>
</button>
